/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Removing_Repeat_Words_CompleteInputs */

const en_removing_repeat_words_complete = /** @type {(inputs: Removing_Repeat_Words_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Removing repeat words complete`)
};

const fr_removing_repeat_words_complete = /** @type {(inputs: Removing_Repeat_Words_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suppression des mots répétés terminée`)
};

const de_removing_repeat_words_complete = /** @type {(inputs: Removing_Repeat_Words_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entfernen von Wiederholungen vollständig`)
};

const it_removing_repeat_words_complete = /** @type {(inputs: Removing_Repeat_Words_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rimozione delle parole ripetute completata`)
};

const ru_removing_repeat_words_complete = /** @type {(inputs: Removing_Repeat_Words_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Удаление повторяющихся слов завершено.`)
};

const es_removing_repeat_words_complete = /** @type {(inputs: Removing_Repeat_Words_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminación completa de palabras repetidas`)
};

const zh_cn2_removing_repeat_words_complete = /** @type {(inputs: Removing_Repeat_Words_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`删除重复词完成`)
};

const ja_removing_repeat_words_complete = /** @type {(inputs: Removing_Repeat_Words_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重複した単語の削除が完了しました`)
};

const hi_removing_repeat_words_complete = /** @type {(inputs: Removing_Repeat_Words_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`दोहराए गए शब्दों को पूरी तरह से हटा दिया गया है।`)
};

const pt_pt2_removing_repeat_words_complete = /** @type {(inputs: Removing_Repeat_Words_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remoção de palavras repetidas concluída`)
};

/**
* | output |
* | --- |
* | "Removing repeat words complete" |
*
* @param {Removing_Repeat_Words_CompleteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const removing_repeat_words_complete = /** @type {((inputs?: Removing_Repeat_Words_CompleteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Removing_Repeat_Words_CompleteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_removing_repeat_words_complete(inputs)
	if (locale === "de") return de_removing_repeat_words_complete(inputs)
	if (locale === "it") return it_removing_repeat_words_complete(inputs)
	if (locale === "ru") return ru_removing_repeat_words_complete(inputs)
	if (locale === "es") return es_removing_repeat_words_complete(inputs)
	if (locale === "zh-CN") return zh_cn2_removing_repeat_words_complete(inputs)
	if (locale === "ja") return ja_removing_repeat_words_complete(inputs)
	if (locale === "hi") return hi_removing_repeat_words_complete(inputs)
	if (locale === "pt-PT") return pt_pt2_removing_repeat_words_complete(inputs)
	return en_removing_repeat_words_complete(inputs)
});